<!-- src/components/VueCollapsible.vue -->

<template>
  <div>
    <span :class="classes">
      <slot name="label"></slot>
      <svg
          v-if="showTrigger"
          @click="open = !open"
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4 mx-1 trigger cursor-pointer"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7"/>
      </svg>
    </span>
    <slot name="content" v-if="open"></slot>
  </div>
</template>

<script>
export default {
  props: {
    classes: {
      type: String,
      default: '',
    },
    showTrigger: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      open: false
    }
  },
  watch: {
    'showTrigger': function (value) {
      if (!value) {
        this.open = false;
      }
    }

  }
}
</script>
